<template>
  <div class="bg-white border-radius-lg">
    <highcharts
      :options="computedOptions"
      class="border-radius-lg p-1"
      style="height: 43dvh;"
    ></highcharts>
  </div>
</template>

<script>
export default {
  name: "ChartTendencias",
  props: {
    categories: {
      type: Array,
      required: true
    },
    anulaciones: {
      type: Array,
      required: true
    },
    ventas: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: "Tendencias de ventas"
    },
    subtitle: {
      type: String,
      default: "Ventas y Anulaciones"
    }
  },
  computed: {
    computedOptions() {
      return {
        chart: { type: 'area' },
        title: { text: this.title },
        subtitle: { text: this.subtitle },
        xAxis: {
          allowDecimals: true,
          type: 'text',
          title: { text: 'Días' },
          labels: {
            rotation: -45,
            style: { fontSize: '10px', fontFamily: 'Verdana, sans-serif' }
          },
          categories: this.categories
        },
        yAxis: {
          title: { text: 'Cantidad de registros' }
        },
        tooltip: {
          pointFormat: '<b>{point.y}</b> (Bs) por {series.name} Registradas'
        },
        plotOptions: {
          area: {
            pointStart: 0,
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 2,
              states: { hover: { enabled: true } }
            }
          }
        },
        series: [
          {
            name: 'Anulaciones',
            data: this.anulaciones,
            color: '#D1D1D1'
          },
          {
            name: 'Ventas',
            data: this.ventas,
            color: '#8B46CD'
          }
        ]
      };
    }
  }
};
</script>